// @flow
import React, { useEffect, useState, useCallback, useMemo } from 'react'
import * as DmsCommon from './../supports/dms-common';
import * as DmsService from './../supports/dms-service';
import { GlobalEvent, GlobalState } from './GlobalContext'
import MsgDialog from './MsgDialog';
import UserGroupAddDialog from './UserGroupAddDialog';
import PropTypes from 'prop-types';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import IconButton from '@mui/material/IconButton';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import CheckIcon from '@mui/icons-material/Check';
import PersonAddAlt1Icon from '@mui/icons-material/PersonAddAlt1';
import PersonRemoveAlt1Icon from '@mui/icons-material/PersonRemoveAlt1';
import EditIcon from '@mui/icons-material/Edit';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import TextField from '@mui/material/TextField';
import ConfirmDialog from './ConfirmDialog';



import { AgGridColumn, AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import 'ag-grid-community/styles/ag-theme-material.css';

export default function UserGroupTab(props) {
  const { sysID, onUpdate } = props;


  // Get Global state and dispatcher
  const [gState, gStateDispatch] = React.useContext(GlobalState);

  const [gEvent, gEventDispatch] = React.useContext(GlobalEvent);

  const [showLoading, setShowLoading] = useState(false);
  const [showError, setShowError] = useState(false);
  const [errMsg, setErrMsg] = useState("");



  const [gridData, setGridData] = useState([]);


  const onCatchPromiseError = (e) => {
    gEventDispatch({
      showErr: true,
      err: e,
    });

  }


  useEffect(() => {
    // console.log("useEffect UserGroupTab[didMount]");

    refreshData();

  }, []);


  const refreshData = async () => {

    if (gridApi)
      gridApi.deselectAll();
    setSelectedRec(null);

    setShowLoading(true);

    try {

      const vGroups = await DmsService.getGroupsPromise(gState.sessionID, sysID);

      setShowLoading(false);

      setGridData(vGroups);

    } catch (e) {
      setShowLoading(false);

      setGridData([]);

      // setErrMsg(e.errMsg || e.message);
      // setShowError(true);

      onCatchPromiseError(e);
    }

  }


  const handleAfterUpdate = () => {

    setOpenAddDialog(false);

    refreshData();

    onUpdate && onUpdate();
  }


  const handleAddClick = (event) => {

    setEditMode(false);
    setOpenAddDialog(true);
  };

  const handleClickEdit = () => {

    // console.log("selectedRec", selectedRec);

    if (selectedRec == null)
      return

    setEditMode(true);
    setOpenAddDialog(true);

  }


  const [gridApi, setGridApi] = useState(null);
  const onGridReady = (params) => {
    setGridApi(params.api);
  };

  const [selectedRec, setSelectedRec] = useState(null);
  const onSelectionChanged = (params) => {
    let nodes = params.api.getSelectedNodes();

    let selRecs = nodes.map(item => {
      return item.data
    });

    // setSelectedRecs(selRecs);
    if (selRecs.length > 0) {
      setSelectedRec(selRecs[0])
    } else {
      setSelectedRec(null)
    }

  }


  const [editMode, setEditMode] = useState(false);
  const [openAddDialog, setOpenAddDialog] = useState(false);


  const [confirmText, setConfirmText] = useState("");
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);

  const handleClickDelete = () => {
    // console.log("selectedRec", selectedRec);
    setConfirmText(`Are you sure to delete the user [${selectedRec.Name}]?`);
    setOpenConfirmDialog(true);
  }

  const handleConfirmDeleteClick = async () => {
    setOpenConfirmDialog(false);

    setShowLoading(true);
    try {
      await DmsService.groupDelPromise(gState.sessionID, sysID, selectedRec.GroupID);

      setShowLoading(false);


      refreshData();

    } catch (e) {
      setShowLoading(false);

      // setErrMsg(e.errMsg || e.message);
      // setShowError(true);
      onCatchPromiseError(e);

    }
  }

  const cellStyle = { paddingLeft: '10px', paddingRight: '10px', fontSize: '0.8rem' };

  const compareStrInsensitive = (aStrA, aStrB) => {
    return aStrA.localeCompare(aStrB, undefined, { sensitivity: "base" })
  }

  const comparatorName = (a, b, nodeA, nodeB) => {
    return compareStrInsensitive(nodeA.data.Name, nodeB.data.Name)
  }

  const comparatorDesc = (a, b, nodeA, nodeB) => {
    return compareStrInsensitive(nodeA.data.Desc, nodeB.data.Desc)
  }

  const columnDefs = useMemo(() => [

    { field: 'Name', headerName: "Group Name", cellStyle: cellStyle, width: 100, flex: "1", comparator: comparatorName, },
    { field: 'Desc', headerName: "Description", cellStyle: cellStyle, width: 100, flex: "1", comparator: comparatorDesc, },
  ], []);

  const handleGetRowId = useCallback((params) => params.data.GroupID, []);

  return (
    // <Box component="div" sx={{ display: 'flex', p: 0, height: 1, maxHeight: 1, overflow: 'auto', bgcolor: 'grey.300' }} >
    <Box sx={{ display: 'flex', flexDirection: 'column', height: "70vh" }} >
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={showLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <MsgDialog
        open={showError}
        title="Error"
        msgText={errMsg}
        onClose={() => setShowError(false)}
      />

      <UserGroupAddDialog
        open={openAddDialog}
        onClose={() => setOpenAddDialog(false)}
        sysID={sysID}
        afterUpdate={handleAfterUpdate}
        editMode={editMode}
        editGroup={selectedRec}
      />


      <Box sx={{ py: 1, px: 1 }} >

        <Button startIcon={<AddIcon />} onClick={handleAddClick} >
          Add
        </Button>

        <Button startIcon={<EditIcon />} onClick={handleClickEdit} disabled={!selectedRec}  >
          Edit
        </Button>

        <Button startIcon={<DeleteIcon />} onClick={handleClickDelete} disabled={!selectedRec}  >
          Delete
        </Button>
        <ConfirmDialog
          open={openConfirmDialog}
          text={confirmText}
          confirmBtnCaption='Delete'
          onCancelClick={() => setOpenConfirmDialog(false)}
          onConfirmClick={handleConfirmDeleteClick}
        />

      </Box>

      <div className="ag-theme-material" style={{ width: '100%', height: '100%', bgcolor: 'yellow' }}>
        <AgGridReact

          rowData={gridData}

          defaultColDef={{
            width: 100,
            resizable: true,
            sortable: true,
            suppressMovable: true,
          }}
          columnDefs={columnDefs}
          headerHeight={40}

          suppressNoRowsOverlay

          rowSelection="single"
          onSelectionChanged={onSelectionChanged}

          getRowId={handleGetRowId}
          onGridReady={onGridReady}
        />
      </div>

    </Box>

  );
}

UserGroupTab.propTypes = {
  sysID: PropTypes.string,
  // docDetail: PropTypes.object,
  onUpdate: PropTypes.func,
};
